import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Input from './Input';
import { isExistFunction } from '../../../../../utils';

const activeClass = 'active-has-value';
const focusClass = 'active-focus';

const LabelTransitionInput = (props) => {
  const {
    label, labelHidden, id: inputId, errorMessage, onInput, type, name, required, inputMode, inputClass,
    colorLabel, formGroupClass, placeholder, isValid, value: inputValue,
    onChange, onFocus, onBlur, onKeyDown, handleRef, iconInput, clickIcon,
  } = props;

  const [isFocusing, setIsActiveFocusing] = useState(false);
  const [isHasValue, setIsActiveHasValue] = useState(false);

  const formInputRef = useRef(null);
  const inputRef = useRef(null);

  const onChangeEvent = (e) => {
    if (isExistFunction(onChange)) {
      onChange(e);
    }
  };

  const onFocusEvent = (e) => {
    setIsActiveFocusing(true);
    if (isExistFunction(onFocus)) {
      onFocus(e);
    }
  };

  const onInputEvent = (e) => {
    if (isExistFunction(onInput)) {
      onInput(e);
    }
  };

  const onBlurEvent = (e) => {
    if (isExistFunction(onBlur)) {
      onBlur(e);
    }
    setIsActiveFocusing(false);
  };

  const onKeyDownEvent = (e) => {
    if (isExistFunction(onKeyDown)) {
      onKeyDown(e);
    }
  };

  const onClickIconEvent = (e) => {
    if (isExistFunction(clickIcon)) {
      clickIcon(e);
    }
  };

  // check if the input has value, add active class
  useEffect(() => {
    const inputElement = inputRef.current;
    if (inputElement) {
      if (inputValue) {
        setIsActiveHasValue(true);
      } else {
        setIsActiveHasValue(false);
      }
    }
  }, [inputValue]);

  // pass the ref to the parent component
  useEffect(() => {
    if (isExistFunction(handleRef)) {
      handleRef(inputRef);
    }
  }, [handleRef]);

  return (
    <Input
      formInputRef={formInputRef}
      inputRef={inputRef}
      inputId={inputId}
      label={label}
      labelHidden={labelHidden}
      type={type}
      name={name}
      colorLabel={colorLabel}
      value={inputValue}
      required={required}
      inputMode={inputMode}
      placeholder={placeholder}
      errorMessage={errorMessage}
      inputClass={inputClass}
      formGroupClass={clsx(formGroupClass, 'form-ani', isFocusing ? focusClass : '', isHasValue ? activeClass : '')}
      isValid={isValid}
      onInput={onInputEvent}
      onKeyDown={onKeyDownEvent}
      onChange={onChangeEvent}
      onFocus={onFocusEvent}
      onBlur={onBlurEvent}
      iconInput={iconInput}
      clickIcon={onClickIconEvent}
    />
  );
};

LabelTransitionInput.propTypes = {
  isValid: PropTypes.bool,
};

LabelTransitionInput.defaultProps = {
  isValid: true,
};

export default LabelTransitionInput;